import React, { useContext, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import styles from './PreAuthenticationDetails.module.scss';
import { useNavigate } from 'react-router-dom';
import BackArrow from '../../../assets/backArrow.svg';
import MenuItemsPageContext, { IMenuItemContext } from '../../Contexts/MenuItemsPageContext/MenuItemsPageContext';

interface IProps {
	storeId: string;
	tableName: string;
	showInfo : boolean;
}

const PreAuthHeader: React.FC<IProps> = (props) => {
	const intl = useIntl();
	const navigate = useNavigate();
	const { storeId, tableName, showInfo} = props;
	const tableRefId = localStorage.getItem('tableRef');
	const { merchantData } = useContext(MenuItemsPageContext) as IMenuItemContext;
	const [merchantName, setMerchantName] = useState<string>('');

	useEffect(() => {
		if (!merchantData) {
			const shopName = localStorage.getItem('merchantName');
			if (shopName) {
				setMerchantName(shopName);
			}
		} else {
			localStorage.setItem('merchantName', merchantData.name);
			setMerchantName(merchantData.name);
			if (merchantData.logoUrl) {
				localStorage.setItem('merchantLogo', merchantData.logoUrl);
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handleBackClick = () => {
		localStorage.removeItem('customerEmail');
		navigate(`/${storeId}?tableRef=${tableRefId}`);
	};

	return (
				<section id="preAuthHeaderContainer" className={`${styles.preAuthHeaderContainer} Container`}>
					<section className={`${styles.preAuthHeaderSubContainer} `}>
						<div className="six column row">
							<div className={styles.top_headerdiv}>
								<button className={styles.backArrow} onClick={handleBackClick}>
									<img src={BackArrow} className={styles.backButton} alt={intl.formatMessage({ id: 'component:image:back:alt' })} />
								</button>
								<h3>{intl.formatMessage({ id: 'page:preAuthHeader:addCard:heading' })}</h3>
							</div>
							<div className={styles.restaurant_div}>
							<div className={styles.dividerContainer}></div>
							<h3 className={styles.restaurantName}>{merchantName}</h3>
							<div className={styles.table_area}>
								<p className={styles.tableText}>
									{intl.formatMessage({ id: 'page:preAuthDetail:table:label' })}
								</p>
								<p className={styles.tableText}> {tableName}</p>
							</div>
							</div>
							
							
							<div className={styles.dividerContainer}></div>
							{ !showInfo && <div className={styles.headinginfo}>{intl.formatMessage({ id: 'page:preAuthDetail:enterInfo:heading' })}</div> } 

						</div>
					</section>
				</section>
		
			
	);
};

export default PreAuthHeader;
